import { AppConfig } from '@services/config.service';
import { UAParser } from 'ua-parser-js';

export function getAppDownloadLink(appConfig: AppConfig | null): string | null {
	if (appConfig == null) return null;

	const parser = new UAParser();
	const userOS = parser.getOS().name;

	if (userOS === 'Android' && appConfig.androidPackageId != null) {
		return `https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=${appConfig.androidPackageId}`;
	}

	if (userOS === 'iOS' && appConfig.appStoreId != null) {
		return `https://itunes.apple.com/se/app/id/${appConfig.appStoreId}?mt=8`;
	}

	return null;
}
